import alert_mixin from '@/utils/mixins/alert_mixin';
import base_methods from './manage_role_base_methods';
import action_methods from './manage_role_action_methods';

export default {
  name: 'ManageRole',
  mixins: [alert_mixin],
  data: () => ({
    roles: [],
    role_groups: [],
    projects: [],
    is_loading: false,
    role_groups_loading: false,
    projects_loading: false,
    creating_role: false,
    creating_role_group: false,
    updating_role: false,
    assigning_projects: false,
    active_inventory_tab: 'roles',
    create_form: {
      role_name: '',
      role_description: '',
      group_id: '',
      new_group_name: '',
      hourly_rate: ''
    },
    create_group_form: {
      name: '',
      description: ''
    },
    edit_form: {
      role_id: null,
      role_name: '',
      role_description: '',
      group_id: '',
      new_group_name: '',
      hourly_rate: ''
    },
    current_role: null,
    is_managing_role: false,
    active_role_tab: 'assignments',
    selected_project_ids: [],
    original_project_ids: []
  }),
  computed: {
    active_roles_count() {
      return this.roles.filter((role) => role.is_active !== false).length;
    },
    described_roles_count() {
      return this.roles.filter((role) => String(role.description || '').trim()).length;
    },
    grouped_roles_count() {
      return this.roles.filter((role) => role.group_id || role.group_name).length;
    },
    inactive_roles_count() {
      return this.roles.filter((role) => role.is_active === false).length;
    }
  },
  mounted() {
    this.fetch_roles();
    this.fetch_role_groups();
    this.fetch_projects();
  },
  methods: {
    ...base_methods,
    ...action_methods
  }
};
